import { Link } from "react-router-dom";
import { useContext } from "react";
import { CartContext } from "../context/CartContext";
import { AuthContext } from "../context/AuthContext";

export default function Navbar() {
  const { cart } = useContext(CartContext);
  const { user, logout } = useContext(AuthContext);

  const cartCount = cart.reduce((s, p) => s + (p.qty || 0), 0);

  return (
    // <header className="sticky top-0 z-50 w-full border-b border-[#e7e3cf] dark:border-[#3d3a2a] bg-background-light/80 dark:bg-background-dark/80 backdrop-blur-md">
    // 	<div className="max-w-[1280px] mx-auto px-6 h-16 flex items-center justify-between">
    // 		<div className="flex items-center gap-10">
    // 			<div className="flex items-center gap-2 cursor-pointer">
    // 				<div className="size-8 bg-primary rounded-lg flex items-center justify-center text-background-dark">
    // 					<span className="material-symbols-outlined font-bold">local_florist</span>
    // 				</div>
    // 				<Link to="/" className="text-xl font-extrabold tracking-tight">
    // 					Elysian<span className="text-primary">Hub</span>
    // 				</Link>
    // 			</div>

    // 			<nav className="hidden lg:flex items-center gap-6">
    // 				<a className="text-sm font-semibold hover:text-primary transition-colors" href="#">Flowers</a>
    // 				<Link to="/products" className="text-sm font-semibold hover:text-primary transition-colors">Artisans</Link>
    // 				<a className="text-sm font-semibold hover:text-primary transition-colors" href="#">Photography</a>
    // 				<a className="text-sm font-semibold hover:text-primary transition-colors" href="#">Decorators</a>
    // 				<a className="text-sm font-semibold hover:text-primary transition-colors" href="#">Planners</a>
    // 			</nav>
    // 		</div>

    // 		<div className="flex items-center gap-4">
    // 			<div className="hidden md:flex items-center bg-[#f3f1e7] dark:bg-[#3d3a2a] rounded-lg px-3 py-1.5 border border-transparent focus-within:border-primary">
    // 				<span className="material-symbols-outlined text-sm text-[#9a8d4c]">search</span>
    // 				<input className="bg-transparent border-none focus:ring-0 text-sm w-48 placeholder:text-[#9a8d4c]" placeholder="Search services..." type="text" />
    // 			</div>

    // 			<Link to="/cart" className="p-2 hover:bg-primary/10 rounded-full transition-colors relative">
    // 				<span className="material-symbols-outlined">shopping_cart</span>
    // 				{cartCount > 0 && (
    // 					<span className="absolute -top-1 -right-1 bg-red-500 text-white text-xs w-5 h-5 rounded-full flex items-center justify-center">{cartCount}</span>
    // 				)}
    // 			</Link>

    // 			{user ? (
    // 				<div className="flex items-center gap-3">
    // 					<span className="hidden sm:inline text-sm font-medium">{user.email}</span>
    // 					<button className="bg-primary text-background-dark px-4 py-2 rounded-lg font-bold text-sm hover:brightness-105 transition-all" onClick={logout}>
    // 						Logout
    // 					</button>
    // 				</div>
    // 			) : (
    // 				<Link to="/login" className="bg-primary text-background-dark px-5 py-2 rounded-lg font-bold text-sm hover:brightness-105 transition-all">
    // 					Login
    // 				</Link>
    // 			)}
    // 		</div>
    // 	</div>
    // </header>

    <header className="sticky top-0 z-50 w-full bg-white/95 backdrop-blur-md">
      <div className="border-b border-[#e7e3cf]">
        <div className="max-w-[1440px] mx-auto px-4 md:px-8 h-20 flex items-center justify-between gap-4">
          <div className="flex items-center gap-4">
            <label
              className="lg:hidden p-2 hover:bg-background-off-white rounded-lg transition-colors flex items-center justify-center cursor-pointer"
              for="mobile-menu-checkbox"
            >
              <span className="material-symbols-outlined text-3xl">menu</span>
            </label>
            <div className="flex items-center gap-2 cursor-pointer">
              <div className="size-9 bg-primary rounded-lg flex items-center justify-center text-background-dark shadow-sm">
                <span className="material-symbols-outlined font-bold text-white">
                  local_florist
                </span>
              </div>
              <h1 className="text-2xl font-extrabold tracking-tight">
                <Link to="/" className="text-xl font-extrabold tracking-tight">Elysian</Link><span className="text-primary">Hub</span>
              </h1>
            </div>
          </div>
          <div className="hidden md:flex flex-1 max-w-2xl mx-8 items-center bg-[#f3f1e7] rounded-full px-4 py-2 border border-[#e7e3cf] focus-within:border-primary focus-within:ring-1 focus-within:ring-primary">
            <span className="material-symbols-outlined text-xl text-[#9a8d4c]">
              search
            </span>
            <input
              className="bg-transparent border-none focus:ring-0 text-sm w-full placeholder:text-[#9a8d4c]"
              placeholder="Search flowers, services, sellers..."
              type="text"
            />
          </div>
          <div className="flex items-center gap-2 md:gap-4">
			{/* <Link to="/cart" className="p-2 hover:bg-primary/10 rounded-full transition-colors relative">
     				<span className="material-symbols-outlined">shopping_cart</span>
    				{cartCount > 0 && (
    					<span className="absolute -top-1 -right-1 bg-red-500 text-white text-xs w-5 h-5 rounded-full flex items-center justify-center">{cartCount}</span>
    				)}
    			</Link> */}
            <Link to="/cart" className="p-2.5 hover:bg-background-off-white rounded-full transition-colors relative">
              <span className="material-symbols-outlined text-2xl">shopping_cart</span>
              {cartCount > 0 && (
                <span className="absolute top-1.5 right-1.5 bg-primary text-[10px] font-bold text-white flex items-center justify-center rounded-full border-2 border-white w-4 h-4">{cartCount}</span>
              )}
            </Link>
            {user ? (
    				<div className="flex items-center gap-3">
    					<span className="hidden sm:inline text-sm font-medium">{user.email}</span>
    					<button className="bg-primary text-background-dark px-4 py-2 rounded-lg font-bold text-sm hover:brightness-105 transition-all" onClick={logout}>
    						Logout
    					</button>
    				</div>
    			) : (
    				<Link to="/login" className="bg-primary text-background-dark px-5 py-2 rounded-lg font-bold text-sm hover:brightness-105 transition-all">
    					Login
    				</Link>
    			)}
          </div>
        </div>
      </div>
      <div className="hidden lg:block border-b border-[#e7e3cf] bg-white">
        <div className="max-w-[1440px] mx-auto px-8 h-12 flex items-center">
          <nav className="flex items-center gap-10">
            <Link to="/products" className="text-sm font-bold text-[#4a4736] hover:text-primary transition-colors border-b-2 border-transparent hover:border-primary py-3">
              Flowers
            </Link>
			<Link className="text-sm font-bold text-[#4a4736] hover:text-primary transition-colors border-b-2 border-transparent hover:border-primary py-3"
              to="/flower-sellers">Flower Sellers</Link>
            <Link
              className="text-sm font-bold text-[#4a4736] hover:text-primary transition-colors border-b-2 border-transparent hover:border-primary py-3"
              href="#"
            >
              Photography
            </Link>
            <Link
              className="text-sm font-bold text-[#4a4736] hover:text-primary transition-colors border-b-2 border-transparent hover:border-primary py-3"
              href="#"
            >
              Decorators
            </Link>
            <Link
              className="text-sm font-bold text-[#4a4736] hover:text-primary transition-colors border-b-2 border-transparent hover:border-primary py-3"
              href="#"
            >
              Planners
            </Link>
            <Link
              className="text-sm font-bold text-[#4a4736] hover:text-primary transition-colors border-b-2 border-transparent hover:border-primary py-3"
              href="#"
            >
              About Us
            </Link>
            <a
              className="text-sm font-bold text-[#4a4736] hover:text-primary transition-colors border-b-2 border-transparent hover:border-primary py-3"
              href="#"
            >
              Contact Us
            </a>
          </nav>
        </div>
      </div>
    </header>
  );
}
